import { useNavigate } from 'react-router-dom'

import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'

import { Enterprise } from '../components/Enterprise/Enterprise'

export const CompanyPage = () => {
  const navigate = useNavigate()

  return (
    <WeScreen
      useNextButton={false}
      useSkipButton={false}
      onClickBack={() => navigate(AppRoutes.settings)}
      hideHeaderOnMobile
    >
      <div className="flex min-h-0 flex-1 flex-col rounded-2xl bg-baseColorHighlight p-6">
        <Enterprise />
      </div>
    </WeScreen>
  )
}
